export default "__VITE_ASSET__BJxrjzLx__"